import Joi from "joi";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, FormGroup, Label, Input } from "reactstrap";
import ButtonComponent from "../../components/ButtonComponent";
import InputComponent from "../../components/InputComponent";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import Toast from "../../helpers/Toast";
import { IHolidayDTO } from "../../models/Holiday/Iholidaydto";
import { IHolidayUpdateDTO } from "../../models/Holiday/Iholidayupdatedto";
import { HolidayService } from "../../services/HolidayService";
import useValidationSchema, { FieldConfig } from "../../components/Validations";

export default function HolidayEdit() {
    const { id } = useParams<{ id: string }>();
    const intl = useIntl();
    const [loadingUpdate, setLoadingUpdate] = useState<boolean>(false);
    const [Holiday, setHoliday] = useState<IHolidayDTO>({} as IHolidayDTO);
    const holidayServiceInstance = new HolidayService();
    const navigate = useNavigate();

     const fields: FieldConfig[] = [
        ["name", "string", "Screens.Holiday.Validation.NameRequired"],
        ["date", "date", "Screens.Holiday.Validation.DateRequired"],
    ];

    const schemaClientValidation = useValidationSchema(fields);

       const getHoliday = async () => {
        setLoadingUpdate(true);
        const response = await holidayServiceInstance.GetHolidaById(Number(id));
        if (response.success === false || response.obj == null) {
            setLoadingUpdate(false);
            Toast.Show("error", response.message);
            return;
        }
        // Corrigir para garantir que o valor booleano é corretamente interpretado
        let isActiveValue = true;
        if (typeof response.obj.isActive === "boolean") {
            isActiveValue = response.obj.isActive;
        } else if (typeof response.obj.active === "boolean") {
            isActiveValue = response.obj.active;
        } else if (typeof response.obj.Active === "boolean") {
            isActiveValue = response.obj.Active;
        }
        setHoliday({ 
            id: response.obj.id, 
            name: response.obj.name, 
            date: response.obj.date,
            isActive: isActiveValue,
            active: response.obj.active,
            Active: response.obj.Active
        });
        setLoadingUpdate(false);
    };

     useEffect(() => {
        getHoliday();
    }, []);

       const editHoliday = async () => {
            setLoadingUpdate(true);
    
            const updatedHoliday: IHolidayUpdateDTO = {
                id: Number(id),
                name: Holiday.name,
                date: Holiday.date,
                Active: Holiday.isActive 
            };
    
            const { error } = schemaClientValidation.validate(updatedHoliday);
            if (error) {
                Toast.Show("error", error.details.map((detail) => detail.message).join(", "));
                setLoadingUpdate(false);
                return;
            }
    
            const response = await holidayServiceInstance.Edit(updatedHoliday);
            setLoadingUpdate(false);
    
            if (response.success !== true) {
                Toast.Show("error", response.message);
                return;
            }
            navigate(-1);
            Toast.Show("success", response.message);
        };

        const handleActiveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            setHoliday({ ...Holiday, isActive: e.target.checked }); 
        };

        return (
        <Layout>
            <div className="pageContainer">
                <div className="pageHeader">
                    <PageTitle title={intl.formatMessage({ id: "Screens.Holiday.EditTitle" })} allowGoBack={true} />
                </div>
                <div className="pageBody">
                    <label style={{ margin: "0px", padding: "13px" }}>
                        <b>Dados do Feriado</b>
                    </label>
                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Row>
                            <InputComponent
                                xl={6}
                                lg={12}
                                md={12}
                                sm={12}
                                xs={12}
                                style={{ width: "100%", borderRadius: "8px" }}
                                type={"text"}
                                value={Holiday?.name}
                                label={intl.formatMessage({ id: "Screens.Holiday.Info.Name" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setHoliday({ ...Holiday, name: t })
                                }}
                            />
                        </Row>
                        <Row>
                            <InputComponent
                                xl={3}
                                lg={6}
                                md={6}
                                sm={12}
                                xs={12}
                                style={{ width: "100%", borderRadius: "8px" }}
                                type={"date"}
                                value={Holiday?.date ? new Date(Holiday.date).toISOString().split('T')[0] : ""}
                                label={intl.formatMessage({ id: "Screens.Holiday.Info.date" })}
                                readOnly={false}
                                onChange={(t: string) => {
                                    setHoliday({ ...Holiday, date: new Date(t) })
                                }}
                            />
                        </Row>
                        <Row>
                            <Col xl={3} lg={6} md={6} sm={12} xs={12}>
                                <FormGroup check style={{ marginTop: "20px", marginLeft: "15px" }}>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            checked={Holiday?.isActive === undefined ? true : Holiday.isActive}
                                            onChange={handleActiveChange}
                                        />{" "}
                                        {intl.formatMessage({ id: "Screens.Holiday.Info.Active" }) || "Ativo"}
                                    </Label>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Row>
                    <Row style={{ margin: "0px", marginTop: "10px", padding: "0px" }}>
                        <Col xl={1} lg={1} md={1} sm={1} xs={1}>
                            <ButtonComponent
                                disabled={loadingUpdate}
                                loading={loadingUpdate}
                                text={intl.formatMessage({ id: "HolidayEdit.Save" })}
                                onClick={editHoliday}
                            />
                        </Col>
                    </Row>
                </div>
            </div>
        </Layout>
    );
}